import { legislationApi } from "./legislationApi";
import { complaintsAPI } from "./complaintsApi";
import { businessPermitsAPI } from "./businessPermitApi";
import { ayudaApi } from "./ayudaApi";

export const adminAPI = {
  legislation: legislationApi,
  ayuda: ayudaApi,
  complaints: complaintsAPI,
  businessPermitsAPI: businessPermitsAPI
};